import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Sucess() {
  const [webhookData, setWebhookData] = useState({
    id: "evt_test_webhook123", // Sample event ID
    type: "charge.succeeded", // Sample event type
    amount: 20, // Sample amount in cents ($20.00)
    currency: "inr", // Sample currency
    description: "Test Charge", // Sample description
  });
  useEffect(() => {
    const purchasef = async () => {
      try {
        const response = await axios.post(
          "http://localhost:5000/webhook",
          webhookData
        );

        console.log(response);

        if (response.status === 200) {
          console.log("Webhook request sent successfully.");
        } else {
          console.error("Failed to send webhook request.");
        }
      } catch (error) {
        console.error("Error sending webhook request:", error);
      }
    };
    purchasef();
  });
  return <div>Success</div>;
}
